export default __webpack_public_path__ + "static/img-ef-13-10e7f48d850aacd66e05ff8998dc13da.png";